import React, { PureComponent } from "react";
import BaseInput from "./BaseInput";
import width from "./helper";
import PageInfo from "../UI/PageInfo";

class SelectInput extends PureComponent {
  render() {
    const {
      input,
      disabled,
      formValues,
      updatedValues,
      formApi,
      schemaProps: {
        placeholder,
        selection,
        selectionKeyValue,
        dynamicSelection,
        dynamicUpdates,
        yearSelection,
        yearRange,
        machine_name,
        value,
        conditionalInput,
        clearSchema,
        prefix,
        restrictStates,
        isInlineModal,
        allowOptionsOnlyOnce,
        master_fieldArray,
        info,
        type,
        parentComponent,
      },
      setFieldArrayExtraInfo,
      counties,
    } = this.props;

    let onlyOneState = false;

    // Filter options
    let filteredSelection;
    if (allowOptionsOnlyOnce) {
      const editRow = formValues?.["add_values_field"]?.[0]?.["rowNum"];
      // Convert master field array into simple array of values
      const masterFieldArrayData = formValues?.[master_fieldArray]?.map(
        (item) => item[machine_name]
      );
      // Filter where options are always allowed and data doesn't already exist
      filteredSelection = selection?.filter((item) => {
        const itemIndex = masterFieldArrayData?.indexOf(item);

        // Item does not already exist
        const isItemUnique = itemIndex === -1;
        // Item is part of current edit
        const isEditRow = itemIndex === editRow;
        // Schema places no "single-use" restrictions
        const isAllowedMultiple = !allowOptionsOnlyOnce?.includes(item);

        return isItemUnique || isAllowedMultiple || isEditRow;
      });
    }
    const selectionResults =
      typeof selection === "function"
        ? selection(formApi, counties)
        : selection;

    onlyOneState =
      typeof selection === "function" ? selectionResults[0] : false;

    const properSelection =
      typeof selection === "function"
        ? selectionResults[1]
        : filteredSelection || selection;

    const clearFields = () => {
      if (isInlineModal) {
        const newValues = {
          ...formApi.getState().values.add_values_field?.[0],
        };
        clearSchema.forEach((field) => {
          newValues[field] = null;
        });
        formApi.change("add_values_field", [newValues]);
      } else {
        clearSchema.forEach((c) => {
          c = prefix ? `${prefix}[0][${c}]` : c;
          formApi.change(c, null);
        });
      }
    };

    if (conditionalInput) {
      let { when, is, operator, input } = conditionalInput;
      switch (operator) {
        case "!==":
          if (
            formApi.getState().values &&
            formApi.getState().values[when] &&
            formApi.getState().values[when] !== is
          ) {
            return <BaseInput {...this.props} />;
          }
          break;
        default:
      }
    }
    // conditionally set another field based on selection
    const dynamicallyUpdate = (e) => {
      const selection = e.target.value;
      if (Array.isArray(dynamicUpdates) && selection) {
        for (let update of dynamicUpdates) {
          // setting something to based on value
          if (update.hasOwnProperty("to") && update.hasOwnProperty("set")) {
            if (!isInlineModal) {
              switch (update.operator) {
                case "!=":
                  if (selection !== update.if) {
                    formApi.change(update.set, update.to);
                  }
                  break;
                default:
                  if (selection === update.if) {
                    formApi.change(update.set, update.to);
                  }
              }
            }
            // setting something based on value, within InlineModal component
            if (!!isInlineModal) {
              const modalValues =
                formApi.getState().values.add_values_field?.[0];
              switch (update.operator) {
                case "!=":
                  if (selection !== update.if) {
                    modalValues[update.set] = update.to;
                    formApi.change("add_values_field", [modalValues]);
                  }
                  break;
                default:
                  if (selection === update.if) {
                    modalValues[update.set] = update.to;
                    formApi.change("add_values_field", [modalValues]);
                  }
              }
            }
          }

          // Update a field by using current select option as a lookup
          if (
            !!isInlineModal &&
            !!update.set &&
            !!update.fromFieldArray &&
            !!update.findValueByChosen
          ) {
            const modalValues = formApi.getState().values.add_values_field?.[0];
            const foundEntry = formApi
              .getState()
              .values?.[update.fromFieldArray]?.find(
                (entry) => entry?.[update.findValueByChosen] === selection
              );
            modalValues[update.set] = foundEntry?.[update.set];
            modalValues[machine_name] = selection;
            formApi.change("add_values_field", [modalValues]);
          }

          // clearing schema based on value
          if (
            update.hasOwnProperty("if") &&
            update.hasOwnProperty("clearSchema")
          ) {
            switch (update.operator) {
              case "!=":
                if (selection !== update.if) {
                  update.clearSchema.forEach((c) => {
                    formApi.change(c, null);
                  });
                }
                break;
              default:
                if (selection === update.if) {
                  update.clearSchema.forEach((c) => {
                    formApi.change(c, null);
                  });
                }
            }
          }

          // clearing files based on value
          if (
            update.hasOwnProperty("if") &&
            update.hasOwnProperty("clearFiles")
          ) {
            const currentFiles =
              formApi.getState().values && formApi.getState().values["files"];
            const hasFiles =
              currentFiles &&
              Array.isArray(currentFiles) &&
              currentFiles.length > 0;
            let shouldClear = false;
            switch (update.operator) {
              case "!=":
                shouldClear = selection != update.if;
                break;
              default:
                shouldClear = selection == update.if;
            }

            if (hasFiles && shouldClear) {
              const updatedFiles = currentFiles.filter(
                (file) => !update.clearFiles.includes(file.machine_name)
              );
              currentFiles.filter((file) => {
                return update.clearFiles.includes(file.machine_name);
              });
              if (
                currentFiles.filter((file) =>
                  update.clearFiles.includes(file.machine_name)
                ).length > 0
              ) {
                formApi.change("files", updatedFiles);
              }
            }
          }
        }
      }
    };

    if (input && input.value === "" && value) {
      formApi.change(machine_name, value);
    }
    let values = [];

    if (!!restrictStates) {
      const { blsFieldName } = restrictStates;
      const blsArea = formApi.getState().values[blsFieldName];
      const restrictedStatesSet = new Set();
      Object.keys(counties).forEach((state) => {
        counties[state].forEach((county) => {
          if (!!county.bls && blsArea === county.bls) {
            restrictedStatesSet.add(state);
          }
        });
      });
      values = Array.from(restrictedStatesSet);
      if (values.length === 1) {
        onlyOneState = true;
      }
    }

    const current_date = new Date();
    const current_year = current_date.getFullYear();
    if (dynamicSelection) {
      dynamicSelection.map((field) => {
        if (typeof field !== "object" && formValues) {
          let val = formValues[field];
          if (val) {
            values.push(val);
          }
        } else {
          // table input support:
          if (field.array_input && formValues) {
            const value_array = formValues[field.array_input];
            if (value_array && value_array.length > 0) {
              value_array.map((obj) => {
                let v = obj[field.relevant_input];
                if (v && values.indexOf(v) === -1) {
                  values.push(v);
                }
              });
            }
          }
        }
      });
    }

    if (yearSelection) {
      // looks like yearSelection: ['current', -1, -2],
      yearSelection.map((o) => {
        if (o === "current") {
          values.push(current_year);
        } else {
          values.push(current_year + o);
        }
      });
    }

    if (yearRange) {
      // looks like yearRange: [1990, "current"]
      const start_year = yearRange[0];
      for (let year = start_year; year <= current_year; year++) {
        values.push(year);
      }
    }

    if (updatedValues) {
      //lets you push new options into the array from prop/state
      updatedValues.map((o) => {
        values.push(o);
      });
    }

    if (
      Array.isArray(placeholder) &&
      Array.isArray(selection) &&
      placeholder?.length === 1 &&
      selection?.length === 1 &&
      placeholder?.[0] === selection?.[0]
    ) {
      formApi.change(machine_name, placeholder[0]);
    }

    return (
      <div>
        {info && info?.position === "top" && <PageInfo {...info} />}
        <select
          disabled={disabled || onlyOneState || false}
          id={input.name}
          className={
            disabled || onlyOneState
              ? `usa-select usa-input-disabled`
              : `usa-select grid-col-${width(this.props.schemaProps)}`
          }
          {...input}
          onChange={(e) => {
            input.onChange(e);
            clearSchema && clearFields();
            dynamicUpdates && dynamicallyUpdate(e);
            if (!!setFieldArrayExtraInfo) {
              setFieldArrayExtraInfo((prev) => ({
                ...prev,
                isInitialStateValue: false,
              }));
            }
            this.props.inputOnChange && this.props.inputOnChange(e);
          }}
        >
          <option key={-1} value={placeholder || "- Select -"}>
            {placeholder || "- Select -"}
          </option>
          {selection &&
            properSelection.map((item, index) => (
              <option key={index} value={item} selected={input.value === item}>
                {item}
              </option>
            ))}
          {selectionKeyValue &&
            selectionKeyValue.map(({ key, value }, index) => {
              return (
                <option key={key} value={key} selected={input.value === key}>
                  {value}
                </option>
              );
            })}
          {(dynamicSelection || yearSelection || yearRange || updatedValues) &&
            values.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
        </select>
        {info && info?.position === undefined && <PageInfo {...info} />}
      </div>
    );
  }
}

export default SelectInput;
